export const columns = function () {
    return [
		{
		    prop: 'orgName',
		    label: '机构名称',
		    minWidth: 100
		},
		{
		    prop: 'insBillId',
		    label: '流水号',
		    minWidth: 100
		},
		{
		    prop: 'bh',
		    label: '单号',
		    minWidth: 100
		},
		{
		    prop: 'saleName',
		    label: '业务员',
		    minWidth: 100
		},
		{
		    prop: 'carNo',
		    label: '车牌号',
		    minWidth: 100
		},
		{
		    prop: 'vin',
		    label: '车架号',
		    minWidth: 150
		},
		{
		    prop: 'carType',
		    label: '车型',
		    minWidth: 100
		},
		{
		    prop: 'personName',
		    label: '被服人',
		    minWidth: 100
		},
		{
		    prop: 'carOwn',
		    label: '车主',
		    minWidth: 100
		},
		{
		    prop: 'beginTime',
		    label: '服务起期',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'endTime',
		    label: '服务止期',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'payType',
		    label: '交费方式',
		    minWidth: 150
		},
		{
		    prop: 'contractFee',
		    label: '标费（元）',
		    minWidth: 150
		},
		{
		    prop: 'cusFee',
		    label: '应交（元）',
		    minWidth: 100
		},
		{
		    prop: 'customerFee',
		    label: '客户应交（元）',
		    minWidth: 100
		},
		{
		    prop: 'feeRatio',
		    label: '手续费比例（%）',
		    minWidth: 100
		},
		{
		    prop: 'fee',
		    label: '手续费',
		    minWidth: 150
		},
		{
		    prop: 'netFee',
		    label: '净费',
		    minWidth: 150
		},
		{
		    prop: 'payMoney',
		    label: '实收金额',
		    minWidth: 150
		},
        {
            prop: 'handle',
            label: '操作',
            minWidth: 100,
            fixed: 'right'
        }
    ]
}

export default {}